module.exports = __webpack_public_path__ + "static/media/atom.87e72261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/atom.svg
// module id = 114
// module chunks = 0